import React from 'react';

import { Button } from '@rtkwlf/fenrir-react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { FourOhFour } from 'ae-components/four-oh-four/four-oh-four';

import ErrorPage, { linkCss } from '../error/error.page';

type NotFoundPageProps = {
  title?: string;
};

const NotFoundPage = ({ title }: NotFoundPageProps) => {
  const { t } = useTranslation('insights');
  const navigate = useNavigate();

  return (
    <ErrorPage
      data-testid="not-found-page"
      backgroundImage="url(/images/404.png)"
      Icon={<FourOhFour />}
      title={title ?? t('notFoundPage.title')}
      Button={
        <Button
          appearance="warning"
          onClick={() => navigate('/reports/dashboards')}
        >
          {t('notFoundPage.button')}
        </Button>
      }
    >
      <Trans
        t={t}
        i18nKey="notFoundPage.content"
        components={[<Link to="/" css={linkCss} />]}
      />
    </ErrorPage>
  );
};

export default NotFoundPage;
